/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ who: NonNullable<unknown> }} Ui_PreviewingInputs */

const en_ui_previewing = /** @type {(inputs: Ui_PreviewingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Previewing as ${i?.who}`)
};

/**
* | output |
* | --- |
* | "Previewing as {who}" |
*
* @param {Ui_PreviewingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const ui_previewing = /** @type {((inputs: Ui_PreviewingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_PreviewingInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_ui_previewing(inputs)
});